import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateUiPipe } from '@core/translation/translate-ui-pipe.pipe';
import { TranslateUiDirective } from '@core/translation/translate.directive';

@NgModule({
  declarations: [TranslateUiDirective, TranslateUiPipe],
  exports: [TranslateUiDirective, TranslateUiPipe],
  imports: [CommonModule]
})
export class TranslateUiModule {}
